import { render, staticRenderFns } from "./SalaryReviews.vue?vue&type=template&id=d820b2da"
import script from "./SalaryReviews.vue?vue&type=script&lang=js"
export * from "./SalaryReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports